import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Virtual consultation",
    tag: "From your living room",
    copy: "Share your medical reports securely. Within 48 hours you are on a video call with the exact surgeon who would operate on you — not a salesperson.",
  },
  {
    n: "02",
    title: "A plan with one fixed price",
    tag: "No hidden anything",
    copy: "You receive a surgeon-signed treatment plan and a single all-inclusive quote: procedure, hospital, hotel, transfers, medication and aftercare.",
  },
  {
    n: "03",
    title: "VIP travel & arrival",
    tag: "Door to door",
    copy: "We handle medical visas, flights and insurance guidance. Your care manager meets you at the arrivals gate — you never navigate India alone.",
  },
  {
    n: "04",
    title: "Procedure & hospitalisation",
    tag: "JCI-accredited centres",
    copy: "Surgery at internationally accredited hospitals with US/EU-trained specialists, private suites and a dedicated OravioCare manager on-site daily.",
  },
  {
    n: "05",
    title: "Five-star recovery",
    tag: "Heal in comfort",
    copy: "Recuperate in a resort-style residence with physiotherapy, chef-planned clinical nutrition and gentle sightseeing once your surgeon approves.",
  },
  {
    n: "06",
    title: "Lifetime aftercare",
    tag: "Long after you fly home",
    copy: "Scheduled tele-follow-ups with your surgeon, a complete digital medical file for your home doctor, and a lifetime line to your care team.",
  },
];

export default function Journey() {
  return (
    <section id="journey" className="scroll-mt-28 bg-brand-deep py-28 text-ivory sm:py-36" data-testid="journey-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">The OravioCare journey</p>
          <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl">
            Six chapters. Zero friction.
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-ivory/60">
            Every patient walks the same carefully choreographed path — designed so the only thing
            you ever think about is getting well.
          </p>
        </Reveal>

        <div className="mt-16">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={0.05 * i}>
              <div
                data-testid={`journey-chapter-${c.n}`}
                className="group grid gap-4 border-t border-ivory/10 py-10 transition-colors duration-500 last:border-b hover:bg-ivory/[0.03] sm:grid-cols-12 sm:items-baseline sm:gap-8"
              >
                <p className="font-mono text-sm tracking-[0.3em] text-gold sm:col-span-2">{c.n}</p>
                <h3 className="font-serif text-3xl font-medium tracking-tight transition-colors duration-500 group-hover:text-gold sm:col-span-4 sm:text-4xl">
                  {c.title}
                </h3>
                <p className="text-sm leading-relaxed text-ivory/60 sm:col-span-4">{c.copy}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/40 sm:col-span-2 sm:text-right">
                  {c.tag}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
